export default function Container({ children, className = "", as: As = "div" }) {
  return (
    <As className={`mx-auto w-full max-w-[1440px] px-6 sm:px-8 md:px-12 lg:px-16 ${className}`}>
      {children}
    </As>
  );
}
